import React from 'react';
import { AppBar, Toolbar, IconButton, Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, Grid, Fab } from '@material-ui/core'
import totalWorks from '../Pics/Logo-TotalWorks.png';
import SpecificComponent from './SpecificComponent';
import DrepturiAcces from '../module/drepturiacces/DrepturiAcces';
import LocalStorage from '../providers/LocalStorage';

import { ReactComponent as MP } from '../Pics/iconsDrawer/MP.svg';
import { ReactComponent as MPProjects } from '../Pics/iconsDrawer/MP_projects.svg';
import { ReactComponent as MPEconomic } from '../Pics/iconsDrawer/MP_economic.svg';
import { ReactComponent as MPDocumente } from '../Pics/iconsDrawer/MP_docs.svg';
import { ReactComponent as HR } from '../Pics/iconsDrawer/HR.svg';
import { ReactComponent as EA } from '../Pics/iconsDrawer/EA.svg';
import { ReactComponent as MA } from '../Pics/iconsDrawer/MA.svg';
import { ReactComponent as DF } from '../Pics/iconsDrawer/DF.svg';
import { ReactComponent as MenuI } from '../Pics/iconsHeader/Menu.svg';
import { ReactComponent as UserI } from '../Pics/iconsHeader/User.svg';










export default class CustomAppBar extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            showDrawer: false,
            openProiect: false,
            openEvaluari: false,
            openAdministrare: false,
            openEvaluareClienti: false,
            openEvaluareColegi: false,
            openEvaluareManageri: false,
            openResurseUmane: false,
            openMonitorizare: false,
            openFinanciar: false,
            showAdmin: true
        }
    }


    drepturiAcces = new DrepturiAcces()
    userData = new LocalStorage().GetUserData().InfoUser

    showDrawer = () => {
        this.setState({ showDrawer: true })
    }

    goNav = (page) => {
        this.inchideDrawer()
        this.props.history.replace(page)
    }

    deschideDrawer = () => {
        this.setState({ showDrawer: true })
    }

    inchideDrawer = () => {
        this.setState({
            showDrawer: false,
            openProiect: false,
            openEvaluari: false,
            openAdministrare: false,
            openEvaluareClienti: false,
            openEvaluareColegi: false,
            openEvaluareManageri: false,
            openResurseUmane: false,
            openMonitorizare: false,
            openFinanciar: false,

            showAdmin: true
        })
    }


    logOut = () => {
        localStorage.removeItem('localUserKey')
        window.location.replace('http://localhost:3000/#/');
        this.props.history.replace('/');
        document.location.reload();
    }

    goToChestionare = () => {
        window.open('http://192.168.100.5:3001')
    }

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            {/* <Fab onClick={(ev) => { this.setState({ openInsert: true }) }}>
                <i className='material-icons'>notification_important</i>

            </Fab> */}
            {/* <Fab style={{ marginLeft: 20, marginRight: 10 }}> */}

                <div  onClick={() => { this.goNav('/managementutilizator') }} className='pm-header-fab-div'>
                    <UserI style={{ width: 20, height: 20 }} />

                </div>

                {/* <i className='material-icons'>person</i> */}

            {/* </Fab> */}
        </div>)

        return rez
    }

    render() {
        return (
            <div data-html2canvas-ignore="true" className='no-print' style={{ flexGrow: 1 }}>
                <AppBar position="fixed" className='pm-header'>
                    <Toolbar style={{ padding: 5 }}>
                        <IconButton className='pm-appbar-burger'
                            aria-label="Menu"
                            onClick={this.showDrawer}
                        >
                            <MenuI style={{ width: 20, height: 20 }} />
                            {/* <i className="material-icons">menu</i> */}
                        </IconButton>

                        <h2 className='pm-header-title' style={{ flex: 1, textAlign: 'left' }} >
                            {this.props.title ? this.props.title : " "}
                        </h2>

                        {
                            this.props.appBarButtons && this.props.appBarButtons.map((b, idx) => {
                                return <div className="appBarButton" key={idx + 'button'}> {b} </div>
                            })
                        }

                        {
                            this.buildAppBarButtons().map((b, idx) => {
                                return <div className="appBarButton" key={idx}> {b} </div>
                            })
                        }



                    </Toolbar>
                </AppBar>

                <Drawer open={this.state.showDrawer} onClose={this.inchideDrawer} >
                    <div
                        className='pm-drawer'
                    >

                        <Grid style={{ padding: 10 }} container>
                            <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                <img onClick={() => { this.goNav(`/`) }} src={totalWorks} style={{ maxWidth: 120, maxHeight: 120 }} alt="" />
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                <IconButton className='pm-appbar-burger'
                                    aria-label="Menu"
                                    onClick={this.inchideDrawer}
                                >
                                    <i className="material-icons">clear</i>
                                </IconButton>
                            </Grid>
                        </Grid>



                        <List component="nav">

                            {/* <ListItem button onClick={() => { this.goNav('/') }} >
                                <ListItemText style={{ color: 'blue' }} primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">home</i> 
                                    {this.dictionary.appBar.drawer.home} </span>} />
                            </ListItem>

                            <Divider className="pm-divider" /> */}

                            {/* <ListItem button onClick={() => { this.goNav(`/users`) }} >
                                <ListItemText style={{ color: 'blue' }} 
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">people</i>  
                                    {this.dictionary.appBar.drawer.users} </span>} />
                            </ListItem>

                            <Divider className="pm-divider" /> */}

                            <ListItem button onClick={() => {
                                this.setState({
                                    openProiect: this.state.openProiect ? false : true,
                                    openEvaluari: false,
                                    openAdministrare: false,
                                    openEvaluareClienti: false,
                                    openEvaluareColegi: false,
                                    openEvaluareManageri: false,
                                    openResurseUmane: false,
                                    openMonitorizare: false,
                                    openFinanciar: false,
                                    showAdmin: this.state.openProiect
                                })
                            }} >
                                <ListItemText style={{ color: 'blue' }}
                                    primary={<span className='pm-appbar-list-text'>
                                        <MP style={{ width: 24, height: 24, marginRight: 10 }} />
                                        {/* <i style={{ verticalAlign: 'super' }} className="material-icons pm-appbar-list-icon">folder</i> */}
                                        <span style={{ display: 'inline-block' }}>
                                            <span style={{
                                                display: 'block',
                                                lineHeight: 0.5,
                                                fontSize: 14
                                            }}>{this.dictionary.appBar.drawer.timpLucru}</span>
                                            <span style={{ fontSize: 12 }}>({this.dictionary.appBar.drawer.projectsManagement}) </span>

                                        </span>   </span>} />
                            </ListItem>

                            {this.state.openProiect &&
                                <List style={{ paddingLeft: 24 }}>
                                    <ListItem button onClick={() => { this.goNav(`/projects`) }} >
                                        <ListItemText style={{ color: 'blue' }}
                                            primary={<span className='pm-appbar-list-text'>
                                                <MPProjects style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                {/* <i className="material-icons pm-appbar-list-icon">import_contacts</i> */}
                                                {this.dictionary.appBar.drawer.projects}  </span>} />
                                    </ListItem>
                                    {this.userData.IsAdmin === 1 &&
                                        <ListItem button onClick={() => { this.goNav(`/arhivaproiecte`) }} >
                                            <ListItemText style={{ color: 'blue' }}
                                                primary={<span className='pm-appbar-list-text'>
                                                    <MP style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                    {this.dictionary.proiecte.arhivaProiecte}  </span>} />
                                        </ListItem>
                                    }



                                    {this.drepturiAcces.getDrepturiAplicatie().acces_extins_proiecte &&
                                        <ListItem button onClick={() => { this.goNav(`/economic`) }} >
                                            <ListItemText style={{ color: 'blue' }}
                                                primary={<span className='pm-appbar-list-text'>
                                                    <MPEconomic style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                    {/* <i className="material-icons pm-appbar-list-icon">attach_money</i> */}
                                                    {this.dictionary.appBar.drawer.economic} </span>} />
                                        </ListItem>
                                    }


                                    {this.drepturiAcces.getDrepturiAplicatie().acces_extins_proiecte &&
                                        <ListItem button onClick={() => { this.goNav(`/documenteproiecte`) }} >
                                            <ListItemText style={{ color: 'blue' }}
                                                primary={<span className='pm-appbar-list-text'>
                                                    <MPDocumente style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                    {/* <i className="material-icons pm-appbar-list-icon">insert_drive_file</i> */}
                                                    {this.dictionary.appBar.drawer.documentsManagement} </span>} />
                                        </ListItem>
                                    }


                                </List>
                            }



                            {/* <Divider className="pm-divider" /> */}



                            {/* <Divider className="pm-divider" /> */}


                            <ListItem button onClick={() => {
                                this.setState({
                                    openResurseUmane: this.state.openResurseUmane ? false : true,
                                    openProiect: false,
                                    openEvaluari: false,
                                    openAdministrare: false,
                                    openEvaluareClienti: false,
                                    openEvaluareColegi: false,
                                    openEvaluareManageri: false,
                                    openMonitorizare: false,
                                    openFinanciar: false,
                                    showAdmin: this.state.openResurseUmane
                                })
                            }} >
                                <ListItemText style={{ color: 'blue' }}
                                    primary={<span className='pm-appbar-list-text'>
                                        <HR style={{ width: 24, height: 24, marginRight: 10 }} />
                                        {/* <i style={{ verticalAlign: 'super' }} className="material-icons pm-appbar-list-icon">people</i> */}

                                        <span style={{ display: 'inline-block' }}>
                                            <span style={{
                                                display: 'block',
                                                lineHeight: 0.5
                                            }}>{this.dictionary.appBar.drawer.pontaj}</span>
                                            <span style={{ fontSize: 12 }}>( {this.dictionary.appBar.drawer.resurseUmane}) </span>

                                        </span>
                                    </span>} />
                            </ListItem>




                            {this.state.openResurseUmane &&
                                <List style={{ paddingLeft: 24 }}>
                                    <ListItem button onClick={() => { this.goNav(`/pontaje`) }} >
                                        <ListItemText style={{ color: 'blue' }}
                                            primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">today</i>
                                                {this.dictionary.appBar.drawer.pontaj}  </span>} />
                                    </ListItem>


                                    {this.drepturiAcces.getDrepturiAplicatie().acces_utilizatori &&
                                        <ListItem button onClick={() => { this.goNav(`/rapoartepontaj`) }} >
                                            <ListItemText style={{ color: 'blue' }}
                                                primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">poll</i>
                                                    {this.dictionary.appBar.drawer.rapoarte} </span>} />
                                        </ListItem>

                                    }

                                    {/* {this.drepturiAcces.getDrepturiAplicatie().acces_utilizatori &&
                                        <ListItem button onClick={() => { this.goNav(`/tichetedemasa`) }} >
                                            <ListItemText style={{ color: 'blue' }}
                                                primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">confirmation_number</i>
                                                    {this.dictionary.appBar.drawer.ticheteDeMasa} </span>} />
                                        </ListItem>
                                    } */}

                                    {/* 
                                    {this.drepturiAcces.getDrepturiAplicatie().acces_utilizatori &&

                                        <ListItem button onClick={() => { this.goNav(`/documentehr`) }} >
                                            <ListItemText style={{ color: 'blue' }}
                                                primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">contact_page</i>
                                                    {this.dictionary.appBar.drawer.templateuri} </span>} />
                                        </ListItem>
                                    } */}

                                    {this.drepturiAcces.getDrepturiAplicatie().acces_utilizatori &&

                                        <ListItem button onClick={() => { this.goNav(`/candidati`) }} >
                                            <ListItemText style={{ color: 'blue' }}
                                                primary={<span className='pm-appbar-list-text'>

                                                    <i className="material-icons pm-appbar-list-icon">people</i>
                                                    <span style={{ display: 'inline-block' }}>
                                                        <span style={{
                                                            display: 'block',
                                                            lineHeight: 0.5
                                                        }}> {this.dictionary.appBar.drawer.candidati}</span>
                                                        <span style={{ fontSize: 12 }}>( {this.dictionary.appBar.drawer.selectiePersonal}) </span>

                                                    </span>
                                                </span>} />
                                        </ListItem>

                                    }

                                    {/* {this.drepturiAcces.getDrepturiAplicatie().acces_utilizatori &&

                                        <ListItem button onClick={() => { this.goNav(`/operatiuni`) }} >
                                            <ListItemText style={{ color: 'blue' }}
                                                primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">import_export</i>
                                                    {this.dictionary.appBar.drawer.operatiuni} </span>} />
                                        </ListItem>
                                    } */}



                                </List>
                            }
                            {this.drepturiAcces.getDrepturiAplicatie().acces_evaluari &&

                                <ListItem button onClick={() => {
                                    this.setState({
                                        openEvaluari: this.state.openEvaluari ? false : true,
                                        openProiect: false,
                                        openAdministrare: false,
                                        openEvaluareClienti: false,
                                        openEvaluareColegi: false,
                                        openEvaluareManageri: false,
                                        openResurseUmane: false,
                                        openMonitorizare: false,
                                        openFinanciar: false,
                                        showAdmin: this.state.openEvaluari
                                    })
                                }} >
                                    <ListItemText style={{ color: 'blue' }}
                                        primary={<span className='pm-appbar-list-text'>
                                            <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                            {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                            {this.dictionary.appBar.drawer.evaluations} </span>} />
                                </ListItem>
                            }

                            {this.state.openEvaluari && this.drepturiAcces.getDrepturiAplicatie().acces_evaluari &&
                                <List style={{ paddingLeft: 24 }}>

                                    <ListItem button onClick={() => {
                                        this.setState({
                                            openEvaluareColegi: !this.state.openEvaluareColegi,
                                            openProiect: false,
                                            openAdministrare: false,
                                            openEvaluareClienti: false,
                                            openEvaluareManageri: false,
                                            openResurseUmane: false,
                                            openMonitorizare: false,
                                            openFinanciar: false,
                                        })
                                    }} >
                                        <ListItemText style={{ color: 'blue' }}
                                            primary={<span className='pm-appbar-list-text'>
                                                <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                                {this.dictionary.appBar.drawer.colegueEvaluations} </span>} />
                                    </ListItem>

                                    {this.state.openEvaluareColegi &&
                                        <List style={{ paddingLeft: 24 }}>
                                            <ListItem button onClick={() => { this.goNav('/evaluaricolegi') }} >
                                                <ListItemText style={{ color: 'blue' }}
                                                    primary={<span className='pm-appbar-list-text'>
                                                        <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                        {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                                        {this.dictionary.appBar.drawer.evaluations} </span>} />
                                            </ListItem>
                                            <ListItem button onClick={() => { this.goNav('/chestionareevaluari/0/colegi') }} >
                                                <ListItemText style={{ color: 'blue' }}
                                                    primary={<span className='pm-appbar-list-text'>
                                                        <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                        {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                                        {this.dictionary.appBar.drawer.questionariesEvaluations} </span>} />
                                            </ListItem>
                                        </List>
                                    }



                                    <ListItem button onClick={() => {
                                        this.setState({
                                            openEvaluareManageri: !this.state.openEvaluareManageri,
                                            openProiect: false,
                                            openAdministrare: false,
                                            openEvaluareClienti: false,
                                            openEvaluareColegi: false,
                                            openResurseUmane: false,
                                            openMonitorizare: false,
                                            openFinanciar: false,
                                        })
                                    }}>
                                        <ListItemText style={{ color: 'blue' }}
                                            primary={<span className='pm-appbar-list-text'>
                                                <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                {/* <i style={{ verticalAlign: 'super' }} className="material-icons pm-appbar-list-icon">fingerprint</i> */}

                                                <span style={{ display: 'inline-block' }}>
                                                    <span style={{
                                                        display: 'block',
                                                        lineHeight: 0.5
                                                    }}>{this.dictionary.appBar.drawer.evaluareaActivitatiiAngajatilor}</span>
                                                    <span style={{ fontSize: 12 }}>(  {this.dictionary.appBar.drawer.managementEvaluations} ) </span>

                                                </span>
                                            </span>} />
                                    </ListItem>

                                    {this.state.openEvaluareManageri &&
                                        <List style={{ paddingLeft: 24 }}>
                                            <ListItem button onClick={() => { this.goNav('/evaluarisefi') }} >
                                                <ListItemText style={{ color: 'blue' }}
                                                    primary={<span className='pm-appbar-list-text'>
                                                        <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                        {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                                        {this.dictionary.appBar.drawer.evaluations}</span>} />
                                            </ListItem>

                                            <ListItem button onClick={() => { this.goNav('/evaluarigenerale') }} >
                                                <ListItemText style={{ color: 'blue' }}
                                                    primary={<span className='pm-appbar-list-text'>
                                                        <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                        {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                                        {this.dictionary.appBar.drawer.generalEvaluation} </span>} />
                                            </ListItem>

                                            <ListItem button onClick={() => { this.goNav('/chestionareevaluari/0/sefi') }} >
                                                <ListItemText style={{ color: 'blue' }}
                                                    primary={<span className='pm-appbar-list-text'>
                                                        <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                        {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                                        {this.dictionary.appBar.drawer.questionariesEvaluations}</span>} />
                                            </ListItem>
                                        </List>
                                    }

                                    <ListItem button onClick={() => {
                                        this.setState({
                                            openEvaluareClienti: !this.state.openEvaluareClienti,
                                            openProiect: false,
                                            openAdministrare: false,
                                            openEvaluareColegi: false,
                                            openEvaluareManageri: false,
                                            openResurseUmane: false,
                                            openMonitorizare: false,
                                            openFinanciar: false,
                                        })
                                    }} >
                                        <ListItemText style={{ color: 'blue' }}
                                            primary={<span className='pm-appbar-list-text'>
                                                <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                                {this.dictionary.appBar.drawer.clientsEvaluations} </span>} />
                                    </ListItem>


                                    {this.state.openEvaluareClienti &&
                                        <List style={{ paddingLeft: 24 }}>

                                            <ListItem button onClick={() => { this.goNav('/evaluariclienti') }} >
                                                <ListItemText style={{ color: 'blue' }}
                                                    primary={<span className='pm-appbar-list-text'>
                                                        <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                        {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                                        {this.dictionary.appBar.drawer.evaluations} </span>} />
                                            </ListItem>
                                            <ListItem button onClick={() => { this.goNav('/chestionareevaluari/0/clienti') }} >
                                                <ListItemText style={{ color: 'blue' }}
                                                    primary={<span className='pm-appbar-list-text'>
                                                        <EA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                        {/* <i className="material-icons pm-appbar-list-icon">fingerprint</i> */}
                                                        {this.dictionary.appBar.drawer.questionariesEvaluations}</span>} />
                                            </ListItem>
                                        </List>
                                    }








                                </List>
                            }

                            {this.drepturiAcces.getDrepturiAplicatie().acces_monitorizare &&
                                <ListItem button  >
                                    <ListItemText style={{ color: 'blue' }} onClick={() => {
                                        this.setState({
                                            openMonitorizare: !this.state.openMonitorizare,
                                            openProiect: false,
                                            openEvaluari: false,
                                            openAdministrare: false,
                                            openEvaluareClienti: false,
                                            openEvaluareColegi: false,
                                            openEvaluareManageri: false,
                                            openResurseUmane: false,
                                            openFinanciar: false,
                                            showAdmin: this.state.openMonitorizare
                                        })
                                    }}
                                        primary={<span className='pm-appbar-list-text'>
                                            <MA style={{ width: 24, height: 24, marginRight: 10 }} />
                                            {/* <i style={{ verticalAlign: 'super' }} className="material-icons pm-appbar-list-icon">visibility</i> */}
                                            <span style={{ display: 'inline-block' }}>
                                                <span style={{
                                                    display: 'block',
                                                    lineHeight: 0.5
                                                }}>{this.dictionary.appBar.drawer.monitorizare}</span>
                                                <span style={{ fontSize: 12 }}>(  {this.dictionary.appBar.drawer.monitorizareaAngajatilor}) </span>

                                            </span>
                                        </span>} />
                                </ListItem>
                            }


                            {this.state.openMonitorizare &&
                                <List style={{ paddingLeft: 24 }}>

                                    <ListItem button onClick={() => { this.goNav(`/monitorizaredaily`) }} >
                                        <ListItemText style={{ color: 'blue' }}
                                            primary={<span className='pm-appbar-list-text'>
                                                <MA style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }} />
                                                {/* <i className="material-icons pm-appbar-list-icon">visibility</i> */}
                                                {this.dictionary.appBar.drawer.monitorizareaAngajatilor} </span>} />
                                    </ListItem>
                                    <ListItem button onClick={() => { this.goNav('/monitorizareraportare') }} >
                                        <ListItemText style={{ color: 'blue' }}
                                            primary={<span className='pm-appbar-list-text'>

                                                <i className="material-icons pm-appbar-list-icon">poll</i>
                                                {this.dictionary.appBar.drawer.raportareMonitorizare}</span>} />
                                    </ListItem>
                                </List>
                            }


                            {/* <Divider className="pm-divider" /> */}
                            {(this.userData.IsAdmin === 1 || this.userData.AccessFinanciar === 1) &&
                                <ListItem onClick={() => { this.goNav(`/diagnosticfinanciar`) }} button  >
                                    <ListItemText style={{ color: 'blue' }}
                                        primary={<span className='pm-appbar-list-text'>
                                            <DF style={{ width: 24, height: 24, marginRight: 10 }} />
                                            {/* <i style={{ verticalAlign: 'super' }} className="material-icons pm-appbar-list-icon">money</i> */}

                                            <span style={{ display: 'inline-block' }}>
                                                <span style={{
                                                    display: 'block',
                                                    lineHeight: 0.5
                                                }}>{this.dictionary.appBar.drawer.evaluareFinanciara}</span>
                                                <span style={{ fontSize: 12 }}>(   {this.dictionary.appBar.drawer.financial} ) </span>

                                            </span>
                                        </span>} />
                                </ListItem>
                            }



                            {/* <Divider className="pm-divider" /> */}



                            {/* <ListItem button onClick={() => { this.goNav('/documenteproiecte') }} >
                                <ListItemText style={{ color: 'blue' }}
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">folder</i>
                                      Manager Documente </span>} />
                            </ListItem> */}

                            {/* <Divider className="pm-divider" /> */}
                            {/* 
                            <ListItem button onClick={() => { this.goNav('/financiarcontabil') }} >
                                <ListItemText style={{ color: 'blue' }} 
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">money</i>  
                                    {this.dictionary.appBar.drawer.pontaj} </span>} />
                            </ListItem>

                            <Divider className="pm-divider" /> */}

                            {/* <ListItem button onClick={() => { this.goNav('/settings') }} >
                                <ListItemText style={{ color: 'blue' }} 
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">settings</i>  
                                    {this.dictionary.appBar.drawer.setari} </span>} />
                            </ListItem>

                            <Divider className="pm-divider" /> */}

                            {/* <ListItem button onClick={() => { this.goNav('/administrare') }} >
                                <ListItemText style={{ color: 'blue' }} 
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">build</i>  
                                    {this.dictionary.appBar.drawer.administrare} </span>} />
                            </ListItem>

                            <Divider className="pm-divider" /> */}

                            {/* <ListItem button onClick={() => { this.goNav('/nomenclatoare') }} >
                                <ListItemText style={{ color: 'blue' }} 
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">style</i>  
                                    {this.dictionary.appBar.drawer.nomenclatoare} </span>} />
                            </ListItem>

                            <Divider className="pm-divider" /> */}

                            {/* <ListItem button onClick={() => { this.goNav('/beneficiari') }} >
                                <ListItemText style={{ color: 'blue' }} 
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">style</i>  
                                    {this.dictionary.appBar.drawer.beneficiari} </span>} />
                            </ListItem>

                            <Divider className="pm-divider" /> */}






                            {/* <ListItem button onClick={() => { this.goNav('/rapoarte') }} >
                                <ListItemText style={{ color: 'blue' }} 
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">money</i>  
                                    {this.dictionary.appBar.drawer.rapoarte} </span>} />
                            </ListItem>

                            <Divider className="pm-divider" /> */}

                            {/* <ListItem button onClick={() => { this.goNav('/chestionare') }} >
                                <ListItemText style={{ color: 'blue' }} 
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">assignment_turned_in</i>  
                                    {this.dictionary.appBar.drawer.chestionare} </span>} />
                            </ListItem>

                            <Divider className="pm-divider" /> */}




                            <Divider className="pm-divider" />

                        </List>
                    </div>



                    <div style={{ position: 'absolute', bottom: 20, padding: 20 }}>




                        {this.state.showAdmin && this.userData.IsAdmin === 1 &&
                            <ListItem button onClick={() => {
                                this.setState({
                                    openAdministrare: this.state.openAdministrare ? false : true,
                                    openProiect: false,
                                    openEvaluari: false,
                                    openEvaluareClienti: false,
                                    openEvaluareColegi: false,
                                    openEvaluareManageri: false,
                                    openResurseUmane: false,
                                    openMonitorizare: false,
                                    openFinanciar: false,
                                })
                            }}>



                                <ListItemText style={{ color: 'blue' }}
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">settings</i>
                                        {this.dictionary.appBar.drawer.administrare} </span>} />
                            </ListItem>
                        }

                        {this.state.openAdministrare &&
                            <List style={{ paddingLeft: 24 }}>
                                <ListItem button onClick={() => { this.goNav(`/managementutilizatori`) }} >
                                    <ListItemText style={{ color: 'blue' }}
                                        primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">people</i>
                                            {this.dictionary.appBar.drawer.userManagement} </span>} />
                                </ListItem>


                                <ListItem button onClick={() => { this.goNav(`/organigrama`) }} >
                                    <ListItemText style={{ color: 'blue' }}
                                        primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">groups</i>
                                            {this.dictionary.appBar.drawer.departmentManagement} </span>} />
                                </ListItem>



                            </List>
                        }

                        {this.state.showAdmin &&
                            <ListItem button onClick={() => { this.logOut() }}>
                                <ListItemText style={{ color: 'blue' }}
                                    primary={<span className='pm-appbar-list-text'><i className="material-icons pm-appbar-list-icon">meeting_room</i>
                                        {this.dictionary.appBar.drawer.logout} </span>} />
                            </ListItem>

                        }



                    </div>
                </Drawer>
            </div>
        );
    }


}  // end class